// @flow
import type { Dispatch } from 'redux';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { models } from '../../utils';
import { setError } from '../error/actions';
import { setQuestion } from '../questions/actions';

export function sendComment(comment: Object, questionId: number) {
  const newComment = {
    body: JSON.stringify(comment.rawContent),
    plain_text: comment.plainText, // eslint-disable-line
    products: comment.products
  };

  return (dispatch: Dispatch) => {
    finectAPI({
      version: 'v3',
      path: `questions/${questionId}/comments`,
      method: 'POST',
      body: newComment,
      onSuccess: (question: Object) => {
        // const modelizedQuestion = models.questions(question);
        // dispatch(setQuestion(modelizedQuestion));
      },
      onError: error => dispatch(setError(error))
    });
  };
}

export function deleteComment(commentId: number, questionId: number) {
  return (dispatch: Dispatch) => {
    finectAPI({
      version: 'v3',
      path: `questions/${questionId}/comments/${commentId}`,
      method: 'DELETE',
      onSuccess: (question: Object) => {
        // const modelizedQuestion = models.questions(question);
        // dispatch(setQuestion(modelizedQuestion));
      },
      onError: error => dispatch(setError(error))
    });
  };
}

// TODO this two actions can be refactored.
export function sendAnswerComment(comment: Object, questionId: number, answerID: number) {
  const newComment = {
    body: JSON.stringify(comment.rawContent),
    plain_text: comment.plainText, // eslint-disable-line
    products: comment.products
  };

  return (dispatch: Dispatch) => {
    finectAPI({
      version: 'v3',
      path: `questions/${questionId}/answers/${answerID}/comments`,
      method: 'POST',
      body: newComment,
      onSuccess: (question: Object) => {
        // const modelizedQuestion = models.questions(question);
        // dispatch(setQuestion(modelizedQuestion));
      },
      onError: error => dispatch(setError(error))
    });
  };
}

export function deleteAnswerComment(commentId: number, questionId: number, answerId: number) {
  return (dispatch: Dispatch) => {
    finectAPI({
      version: 'v3',
      path: `questions/${questionId}/answers/${answerId}/comments/${commentId}`,
      method: 'DELETE',
      onSuccess: (question: Object) => {
        // const modelizedQuestion = models.questions(question);
        // dispatch(setQuestion(modelizedQuestion));
      },
      onError: error => dispatch(setError(error))
    });
  };
}
